import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/LuckyGift/Rules',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LuckyGift-FindTreasure-Rules" */ '~/pages/LuckyGift/FindTreasure/Rules'
        )
    ),
  },
  {
    path: '/LuckyGift/FindTreasure',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LuckyGift-FindTreasure" */ '~/pages/LuckyGift/FindTreasure'
        )
    ),
  },
  {
    path: '/LuckyGift/FindTreasure/Box',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LuckyGift-FindTreasure" */ '~/pages/LuckyGift/FindTreasure'
        )
    ),
  },
  {
    path: '/LuckyGift/History',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LuckyGift-FindTreasure-History" */ '~/pages/LuckyGift/FindTreasure/History'
        )
    ),
  },
] as RouteConfig[]
